import { groupBy } from '../../../../server/util';
import React, { Component, Fragment } from 'react';

class SchoolWiseTable extends Component {
    constructor(props){
        super(props);
    }
    formatData=()=>{
        const {totalStudents, totalMealServed, totalAlacarteServed, totalTransactionData}=this.props.data;
        const totalStudentsGroup=groupBy(totalStudents.data.resp||[],'mealSchoolId');
        const totalMealsGroup=groupBy(totalMealServed.data.resp||[],'mealSchoolId');
        const totalAlacarteGroup=groupBy(totalAlacarteServed.data.resp||[],'mealSchoolId');
        const totalTransactionGroup=groupBy(totalTransactionData.data.resp||[],'mealSchoolId');
        return Object.keys(totalStudentsGroup).map(key=>{
            const mealObj=((totalMealsGroup[key]||[])[0]||{});
            const alacarteObj=((totalAlacarteGroup[key]||[])[0]||{});
            const transObj=((totalTransactionGroup[key]||[])[0]||{});
            return {
                mealSchoolId:key,
                school:((totalStudentsGroup[key]||[])[0]||{}).schoolName,
                totalStudents:((totalStudentsGroup[key]||[])[0]||{}).count,
                totalMeals:mealObj.count||0,
                totalAlacarte:alacarteObj.count||0,
                totalTrans:transObj.count||0
            }
        })
    }
    render() {
        
        return (
            <Fragment>
                <div className='panel'>
                    <div className='panel-body' style={{maxHeight:'300px', overflowY:'scroll'}}>
                    <div className='table-responsive'>
                <table className='table table-bordered table-sm table-hover'>
                    <thead>
                        <tr>
                            <th>School</th>
                            <th>Total Active Students</th>
                            <th>Total Meal Served</th>
                            <th>Total A La Carte Served</th>
                            <th>Total Transactions</th>
                            <th>Total Revenue</th>
                        </tr>

                    </thead>
                    <tbody >
                        {
                            this.formatData().map((item,k)=>{
                                return <tr>
                                    <td>{item.school}</td>
                                    <td>{item.totalStudents}</td>
                                    <td>{item.totalMeals}</td>
                                    <td>{item.totalAlacarte}</td>
                                    <td>{item.totalTrans}</td>
                                    <td>{''}</td>
                                </tr>
                            })
                        }

                    </tbody>
                </table>
                </div>

                    </div>
                </div>
                
            </Fragment>
        );
    }
}
export default SchoolWiseTable;


// WEBPACK FOOTER //
// ./src/components/SuperAdmin/Home/DashboardItems/schoolWiseTable.jsx